import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IExpenseForm } from "../../data/entities";
import { ExpenseForm } from "../components/form";
import { expenseRedux } from "../state/state";

export const ExpenseCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IExpenseForm): Promise<void> => {
    await dispatch(expenseRedux.actions.create(values));
    history.push(ROUTES.expense);
  };

  const createExpenseBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.expense.create);

  return <ExpenseForm branch={createExpenseBranch} onSubmit={onSubmit} initialData={null} submitTitle="Create" />;
};
